import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 22L9 19H5C3.89543 19 3 18.1046 3 17V4C3 2.89543 3.89543 2 5 2H19C20.1046 2 21 2.89543 21 4V17C21 18.1046 20.1046 19 19 19H15L12 22ZM5 4V17H10L12 19L14 17H19V4H5ZM16 14.986H8V14.6C8.11835 12.5051 9.90424 10.8978 12 11C14.0958 10.8978 15.8816 12.5051 16 14.6V14.985V14.986ZM12 10C11.4641 10.0186 10.9445 9.8139 10.5653 9.43471C10.1861 9.05553 9.98138 8.53593 10 8C9.98168 7.46416 10.1865 6.94474 10.5656 6.56562C10.9447 6.1865 11.4642 5.98168 12 6C12.5358 5.98168 13.0553 6.1865 13.4344 6.56562C13.8135 6.94474 14.0183 7.46416 14 8C14.0186 8.53593 13.8139 9.05553 13.4347 9.43471C13.0555 9.8139 12.5359 10.0186 12 10Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "UserPin"
);
